"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const _ClockIcon = createIcon({
  displayName: "_ClockIcon",
  viewBox: "0 0 500 500",
  path: (
    <>
      <path
        d="m250 40c-115.97979 0-210 94.0202-210 210s94.02021 210 210 210 210-94.0202 210-210-94.02021-210-210-210zm0 19.09375 50.6875 177.375h-.03125c1.28561 4.57324 1.96875 9.38875 1.96875 14.375 0 29.18623-23.5544 52.84375-52.625 52.84375-29.07061 0-52.625-23.65752-52.625-52.84375 0-4.98625.68314-9.80176 1.96875-14.375h-.0625zm0 65.8125-33.34375 116.65625h.03125c-.84551 3.00771-1.3125 6.15815-1.3125 9.4375 0 19.19513 15.50592 34.75 34.625 34.75 19.11911 0 34.625-15.55487 34.625-34.75 0-3.27935-.46699-6.42979-1.3125-9.4375h.03125z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default _ClockIcon;
